import React, { useEffect, useState } from "react";
import { ONLY_OFFICE_JS } from  "helpers/ApiEndpointConstants";
import { connect } from "react-redux";

// import ViewDocument from "../components/ViewDocument/ViewDocument";

import {
    loadDocumentAction,
} from "store/actions/Actions";

import styles from "./DashboardViews.module.scss";

const DocumentView = (props) => {
    const { task, loadDocumentAction, document } = props;
    const [isEditorLoaded, setIsEditorLoaded] = useState(false);

    useEffect(() => {
        // inject only office widget javascript
        const script = window.document.createElement("script");
        script.src = ONLY_OFFICE_JS;
        script.async = false;
        window.document.body.appendChild(script);
        
        script.onload = function() {
            setIsEditorLoaded(true);
        };

        return () => {
            window.document.body.removeChild(script);
        };
    }, []);


    useEffect(() => {
        loadDocumentAction({ id: task.subtask_data.document });
    },  [task.id, loadDocumentAction]);

    useEffect(() => {
        if (document)  {
            const { config } = document;
            config['height'] = "1000px";
            config['document']['permissions']['comment'] = false;
            config['document']['permissions']['download'] = false;
            config['document']['permissions']['edit'] = false;
            config['document']['permissions']['fillForms'] = false;
            config['document']['permissions']['modifyContentControl'] = false;
            config['document']['permissions']['modifyFilter'] = false;
            config['editorConfig']['mode'] = 'view';
            
            // config['editorConfig']['user']['id'] = props.userData.id;
            // config['editorConfig']['user']['name'] = props.userData.name;

            if (isEditorLoaded) {
                if (window.DocsAPI) {
                    new window.DocsAPI.DocEditor("editor", config);
                }
            }

        }
    }, [document, isEditorLoaded]);

    return (
        <div className={styles.document}>
            <div className={styles.viewer}>
                <div id="editor">Loading document...</div>
            </div>
        </div>
    );
}

// export default DocumentView;


const mapStateToProps = state => ({
    document: state.DocumentReducer.document,
    // userData: state.AuthReducer.userData,
    // UserOrgSiteReducer: state.UserOrgSiteReducer
});

const mapDispatchToProps = {
    loadDocumentAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(DocumentView);
